/**
 * Created by luka on 23.02.2018.
 */
import {get} from "../utils/api";
import { navigationToWorkoutPreview} from "../navigation/NavigationActions";
import {
    LOADING_WORKOUT_FAILED, WORKOUT_ALREADY_MISSED, WORKOUT_FETCH_DATA_SUCCESS,
    WORKOUT_LOADING
} from "../actions/types";
import {CURRENT_PENDING, MISSED, TOMORROW} from "../overview/DayStates";
import {daysFetchData} from "../overview/OverviewAction";

export function loadingWorkoutFailed(error) {
    return {
        type: LOADING_WORKOUT_FAILED,
        error
    };
}

export function workoutAlreadyMissed() {
    return {
        type: WORKOUT_ALREADY_MISSED,
    };
}

export function workoutLoading(bool) {
    return {
        type: WORKOUT_LOADING,
        isLoading: bool
    };
}

export function workoutFetchDataSuccess(day) {
    return {
        type: WORKOUT_FETCH_DATA_SUCCESS,
        day
    };
}

export function workoutFetchData(dayId) {
    return (dispatch) => {
        dispatch(workoutLoading(true));

        get(`day/${dayId}`)
            .then((dayResponse) => {

                if (dayResponse.state === MISSED) {
                    //user already missed this day. Can happen if user does not refresh overview and then makes the workout call
                    dispatch(workoutAlreadyMissed());
                    dispatch(daysFetchData()); //refresh users days list so he can see thats missed
                    dispatch(workoutLoading(false));
                    return
                }

                if(dayResponse.day.state === CURRENT_PENDING || dayResponse.day.state === TOMORROW){
                    dispatch(workoutFetchDataSuccess(dayResponse.day));
                    dispatch(navigationToWorkoutPreview());
                    dispatch(workoutLoading(false));
                    return
                }
                dispatch(workoutLoading(false));
            })
            .catch((error) => {
                dispatch(loadingWorkoutFailed(error));
                dispatch(workoutLoading(false));
            });

    };
}



// WEBPACK FOOTER //
// ./src/workout/WorkoutAction.js